<div class="page" [ngClass]="{'activeCmpt' : !modoEstandar}">

  <div class="header">
    <div class="titleClock">
      <h1 class="text-nowrap">SINÓPTICO</h1>
      <div class="reloj">{{horaActual}}</div>

      <div class="modo" (click)="modoEstandar = !modoEstandar" [ngClass]="{'activeCmpt' : !modoEstandar}">
        <div class="but">ESTANDAR</div>
        <div class="but">COMPACTO</div>
      </div>
    </div>

    <div class="terminal" [tooltip]="sucursalesSelectedNombresLargos">
      <p><strong>TERMINAL:</strong> {{sucursalesSelectedNombres}}</p>
      <button class="btn btnBlack" (click)="openModalCambiarSucursal()">CAMBIAR</button>
    </div>
  </div>


  <div class="boxWhite">
    <div class="headBox">
      <div class="filtros">
        <div class="buscar itemForm">
          <input type="search" class="form-control" placeholder="Buscar Conductor..." (input)="onInput($event)">
        </div>

        <div class="select itemForm d-lg-block d-none" [tooltip]="getServiciosSentidosSeleccionados()">
          <ng-select class="select select-width" placeholder="Servicio/Sentido"
            [(ngModel)]="servicioSentidoSeleccionado" (change)="onServicioSentidoChange()" [items]="serviciosSentidos"
            bindLabel="label" bindValue="value" [multiple]="true" appendTo="body" [closeOnSelect]="false">
            <ng-template ng-multi-label-tmp let-items="items">
              <span style="display:block; font-size: 13px; top: 7px;color: var(--black)" class="ng-placeholder"
                *ngIf="items.length > 1">{{items.length}} Seleccionados</span>
              <span style="display:block; font-size: 13px; top: 7px; color: var(--black)" class="ng-placeholder"
                *ngIf="items.length == 1">{{items[0].label}}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="btnSync">
        <div class="ico" (click)="reload()" [tooltip]="'Recargar datos'">
          <img src="assets/img/icoRefresh.svg" alt="">
        </div>
        <ng-select class="selectNg" [items]="recargas" bindLabel="label" bindValue="value" [(ngModel)]="recarga"
          placeholder="RECARGAR CADA..." (change)="calcularTime()" (clear)="recarga = 0; calcularTime()">
        </ng-select>
        <div class="barra" *ngIf="recarga != 0">
          <progressbar [max]="recarga/1000" [value]="contador/1000" [animate]="true" [striped]="true">
          </progressbar>
        </div>
      </div>



    </div>

    <div class="tableResp" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="150"
      (scrolled)="onScroll()" [scrollWindow]="false" [alwaysCallback]="false"
      [infiniteScrollDisabled]="desactivarInfiniteScroll">
      <table class="table">
        <thead>
          <tr>
            <th [tooltip]="'ID del viaje'" placement="bottom" container="body">ID VIAJE</th>
            <th [tooltip]="'Hora de inicio del viaje'" placement="bottom" container="body">INICIO</th>
            <th [tooltip]="'Terminal de origen'" placement="bottom" container="body">ORIGEN</th>
            <th [tooltip]="'Servicio'" placement="bottom" container="body">SERVICIO</th>
            <th [tooltip]="'Sentido'" placement="bottom" container="body">SENTIDO</th>
            <th [tooltip]="'Terminal de destino'" placement="bottom" container="body">DESTINO</th>
            <th [tooltip]="'Llegada / Tiempo restante'" placement="bottom" container="body">LLEGADA/T.R</th>
            <th [tooltip]="'Patente del bus'" placement="bottom" container="body">PATENTE BUS</th>
            <th [tooltip]="'ID del conductor'" placement="bottom" container="body">ID CB</th>
            <th [tooltip]="'Estado del viaje'" placement="bottom" container="body">ESTADO</th>
            <th [tooltip]="'Acciones del viaje'" placement="bottom" container="body">ACCIÓN</th>
          </tr>
        </thead>


        <tbody>
          <tr *ngFor="let viaje of listaViajes">
            <td>{{viaje.viajeCodigo}}</td>
            <td>{{muestraHora(viaje.fechahoraInicio)}} <span
                class="miniTiempo textoRojo">{{muestraDiferenciaMinutos(viaje.fechahoraInicio,
                viaje.fechahoraSalida)}}</span></td>
            <td>{{viaje.sucursalOrigen.nombre}}</td>
            <td [tooltip]="viaje.sondaServicioSentido ? viaje.sondaServicioSentido.split('_').join(' ') : null">
              <div class="badge"
                [ngClass]="'sonda-' + (viaje.sondaServicioSentido || 'NO_CALCULADO').toLowerCase().replace('_', '-')">
                {{ viaje.servicio }}
              </div>
            </td>
            <td>
              <div class="badge"
                [ngClass]="'sonda-' + (viaje.sondaServicioSentido || 'NO_CALCULADO').toLowerCase().replace('_', '-')">
                {{ viaje.sentido }}
              </div>
            </td>
            <td>{{viaje.sucursalDestino.nombre}}</td>

            <ng-template #t [ngTemplateOutlet]="t" let-a
              [ngTemplateOutletContext]="{ $implicit: muestraDiferenciaHorasMinutos(viaje.fechahoraTermino, viaje.fechahoraLlegada) }">
              <td>{{muestraHora(viaje.fechahoraTermino)}}
                <span class="miniTiempo" [ngClass]="{'textoRojo': a.indexOf('+') == 0}">{{a}}</span>
              </td>
            </ng-template>

            <td>
              <div class="badge">{{viaje.movil?.patente}}</div>
            </td>
            <td>
              <div class="badge">{{viaje.conductor?.visibleId}}</div>
            </td>
            <td [ngClass]="{'textoRojo': viaje.estado == statusViajeFinalizado}">{{viaje.estado.replace('_', ' ')}}</td>
            <td>
              <div class="btns">
                <span *ngIf="tienePermisoVerDetalle()" [tooltip]="'Ver viaje'">
                  <button class="btn btnVer" (click)="verViaje(viaje)"><img src="assets/img/icoVer.svg"></button>
                </span>
                <span *ngIf="viaje.estado != statusViajeFinalizado && tienePermisoFinalizarViaje()"
                  [tooltip]="'Terminar viaje'">
                  <button class="btn btnTerminar" (click)="terminarViaje(viaje)"><img
                      src="assets/img/icoTerminarViaje.svg"></button>
                </span>
                <span *ngIf="tienePermisoImprimirPlanilla()" [tooltip]="'Imprimir planilla'">
                  <button class="btn btnImprimir" (click)="muestraModalImprimirColacionRutaViaje(viaje)"><img
                      src="assets/img/icoPrint.svg" alt=""></button>
                </span>
              </div>
            </td>
          </tr>
        </tbody>

      </table>
    </div>


  </div>


</div>